import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Game } from '../../../Core'

import * as selectors from '../battles.selectors'
import * as actions from '../battles.actions'
import * as audioActions from '../../../Core/Game/AudioContainer/audio.actions'

import CheckBattle from './CheckBattle'

const mapDispatchToProps = (dispatch) => {
  return {
    removeScreen: bindActionCreators(Game.actions.removeScreen, dispatch),
    getBattle: bindActionCreators(actions.getBattle, dispatch),
    removeQuestion: bindActionCreators(actions.setBattleQuestion, dispatch),
    removeInfo: bindActionCreators(actions.setBattleInfo, dispatch),
    removeResume: bindActionCreators(actions.setBattleResume, dispatch),
    addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
    setIndividualBattle: bindActionCreators(actions.setIndividualBattle, dispatch),
  }
}
const mapStateToProps = (state) => ({
  info: selectors.getBattleInfoFromState(state),
  results: selectors.getBattleResults(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CheckBattle))
